const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");

export const fetchStockSplitData = async (filterStatus = '') => {
    try {
      const url = filterStatus
        ? `${BASE_URL}/getStockSplitCalender?splitStatus=${filterStatus}`
        : `${BASE_URL}/getStockSplitCalender`;
      
      const response = await fetch(url,  {
          method: "GET",
          headers: {
              Authorization: `Bearer ${token}`
          }
      })
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error('Error fetching stock split data');
      }
  
      return result;
    } catch (error) {
      console.error('Error fetching stock split data:', error);
      throw error;
    }
  };
  
 // Updated addStockSplitData function
export const addStockSplitData = async (formData) => {
  try {
    const response = await fetch(`${BASE_URL}/saveStockSplitCalender`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Error adding stock split data');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error adding stock split data:', error);
    throw error;
  }
};

  
  // Function to update existing stock split data
  export const editStockSplitData = async (formData) => {
    try {
      const response = await fetch(`${BASE_URL}/updateStockSplitCalender`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
           Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(formData),
      });
 
      if (!response.ok) {
        throw new Error('Error updating stock split data');
      }
 
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error updating stock split data:', error);
      throw error;
    }
 };
 
  